import { LogisticsService } from 'src/app/features/transport-operation/services/logistics.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Injector, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { ExpenseService } from 'src/app/core/services/expense.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { BookingService } from 'src/app/features/transport-operation/services/booking.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { finalize } from 'rxjs';

@Component({
  selector: 'laas-billing-preview-calculate',
  templateUrl: './billing-preview-calculate.component.html',
  styleUrls: ['./billing-preview-calculate.component.scss']
})

export class BillingPreviewCalculateComponent extends SessionBaseComponent implements OnInit {
  @Input() display!: boolean;
  @Input() bookingNo!: any;
  @Input() feature!: any;
  @Output() onClose = new EventEmitter<boolean>();
  @Input() redeliveryCount: number | null;
  @Input() previewBillingCbType!: any;

  columns: any[];
  previewBeans: any[] = [];
  feeTypeOptions: any[] = [];
  shippingTypeOptions: any[] = [];
  selectedCategory: any = null;
  selectedCategories: any[] = [];

  billingReq: any | undefined = {
    billingCollections: []
  }
  isLoading: boolean = false;
  isSaveBillingLoading: boolean = false;
  isMultipleRfqChoose: boolean = false;

  constructor(injector: Injector,
    private dropdownOptionsService: DropdownOptionsService,
    private expenseService: ExpenseService,
    private logisticsService: LogisticsService) {
    super(injector);
    this.columns = [

      { field: '', header: ' ' },
      { field: 'preCurrencyCode', header: 'ReceiptFormGenerateCost.AccountingCurrency' },
      { field: 'estimateTotalCharge', header: 'ReceiptFormGenerateCost.EstimateTotalAnt' },
      { field: 'rfqFeeType', header: 'ReceiptFormGenerateCost.CostType' },
      { field: 'accountCode', header: 'ReceiptFormGenerateCost.AccountingType' },
      { field: 'shippingType', header: 'ReceiptFormGenerateCost.ShippingMethod' },
      { field: 'shippingSectionDesc', header: 'ReceiptFormGenerateCost.TransportSectionDescription' },
      { field: 'estimatedAmountDesc', header: 'ReceiptFormGenerateCost.FeeRemarks' },

      { field: 'estimatedAmount', header: 'ReceiptFormGenerateCost.EstimateCharges' },
      { field: 'preCurrencyCode', header: 'ReceiptFormGenerateCost.EstimateCostCurrency' },
      { field: 'rate', header: 'ReceiptFormGenerateCost.ExchangeRate' },
    ];
    this. redeliveryCount = 0;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.dropdownOptionsService.findFeeTypeByFeeTypeCategory("RFQ")
      .subscribe({
        next: (options: any[]) => {
          this.feeTypeOptions = options.map(x => ({ label: x.feeTypeName, value: x.feeTypeCode }));
        }
      });
      this.dropdownOptionsService.findFacilityOptionsByOptionType("ShippingType")
      .subscribe({
        next: (options: any[]) => {
          this.shippingTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

      if (this.feature === "CrossBoundry") {
        this.isMultipleRfqChoose = true;
      }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.display) {
      return;
    }

    this.selectedCategories = [];
    this.previewBeans = [];
    if (!isNullOrEmpty(this.bookingNo)) {
      this.isLoading = true;
      // this.expenseService.getTransPreviewCalculate('02BA2107295001', this.feature).subscribe({
      this.expenseService.getTransPreviewCalculate(this.bookingNo, this.feature)
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe({
          next: (resolve: any[]) => {
            this.previewBeans = resolve;
            console.log(this.previewBeans);
            if (this.previewBeans != null && this.previewBeans.length > 0) {
              this.previewBeans.forEach((element, index) => {
                if (element.detailEntities == null || element.detailEntities.lenth == 0) {
                  this.previewBeans.splice(index, 1);

                } else {
                  (element.detailEntities as any[]).forEach(item => {
                    if (!isNullOrEmpty(item.rfqFeeType)) {
                      let items: any[] = this.feeTypeOptions.filter(x => x.value == item.rfqFeeType);
                      item.feeTypeLabel = items.length > 0 ? items[0].label : item.rfqFeeType;
                    }
                    if (!isNullOrEmpty(item.accountCode)) {
                      console.log('this.feature:', this.feature);
                      this.expenseService.billingViewerAccountCodeMap(element.headerEntity.billingType, this.feature).subscribe({
                        next: (expenseAccounts: any[]) => {
                          let items: any[] = expenseAccounts.map(x => ({ label: (x.accountCode + '(' + x.accountDesc + ')'), value: x.accountCode }))
                                                            .filter(x => x.value == item.accountCode);
                          item.accountCodeLabel = items.length > 0 ? items[0].label : item.accountCode;

                        }
                      });
                    }
                    if (!isNullOrEmpty(item.shippingType)) {
                      let items: any[] = this.shippingTypeOptions.filter(x => x.value == item.shippingType);
                      item.shippingTypeLabel = items.length > 0 ? items[0].label : item.shippingType;
                    }
                  });
                }
              });

              // 若是CB/CT可能會觸發自動產生費用，不用User手選
              if (this.feature == "CrossBoundry") {
                this.autoSaveCbBilling();
              }

            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastErrorMessage(err.error);
          }
        }
      );
    }
  }

  hideDialog(event: any): void {
    this.onClose.emit(this.display);
  }

  autoSaveCbBilling(): void {
    console.log("autoSaveCbBilling this.previewBeans.length = ", this.previewBeans.length);
    console.log("autoSaveCbBilling this.previewBillingCbType = ", this.previewBillingCbType);

    const cbType1Group = [1, 2, 3, 6];
    const cbType2Group = [4, 5];

    if (cbType1Group.includes(this.previewBillingCbType)) {
      // 類型1、2、3、6，如果只有一條RFQ，就直接自動Save
      if (this.previewBeans.length == 1) {
        this.selectedCategories = this.previewBeans;
        this.save();
      }

    } else if (cbType2Group.includes(this.previewBillingCbType)) {
      // 類型4、5，如果只有2條RFQ，就直接自動Save
      if (this.previewBeans.length == 2) {
        this.selectedCategories = this.previewBeans;
        this.save();
      } else if (this.previewBeans.length == 1 && this.previewBillingCbType==5) {

        this.toastService.warn(this.translateService.instant('BillingPreview.Message.ImportRFQWarning'));
      } else if (this.previewBeans.length == 1 && this.previewBillingCbType==4) {
        this.toastService.warn(this.translateService.instant('BillingPreview.Message.ExportRFQWarning'));
      }
    } else {
      return;
    }

  }

  save(): void {

    const categoriesToSave = this.isMultipleRfqChoose
    ? this.selectedCategories: [this.selectedCategory];

    console.log("save categoriesToSave = ", categoriesToSave);

    this.billingReq.billingCollections = [];

    categoriesToSave.forEach(category => {
      category.headerEntity.createUser = this.userProfile.userName;
      category.headerEntity.updateUser = this.userProfile.userName;

      this.billingReq.billingCollections.push({
        bill: category.headerEntity,
        billDetails: category.detailEntities,
        detailInfoEntities: category.detailInfoEntities
      });
    });

    this.isSaveBillingLoading = true;
    this.expenseService.saveBilling(this.billingReq)
      .pipe(finalize(() => (this.isSaveBillingLoading = false)))
      .subscribe({
        next: result => {
          this.logisticsService.isFeeCalCulation(this.feature, this.bookingNo, 'Y').subscribe({
            next: result => {
              this.toastService.success("儲存成功");
              this.display = false;
              this.onClose.emit(this.display);
            },
            error: result => {
              this.toastService.error("儲存更新狀態失敗");
            }
          });
        },
        error: err => {
          this.toastErrorMessage(err.error);
        }
      }
    );
  }
}
